var map = {
	"./chartjs.png": "a387",
	"./chrome.png": "da95",
	"./covid19.png": "170d",
	"./figma.png": "68c7",
	"./firebase.png": "2a3e",
	"./html.png": "c2c5",
	"./illustrator.png": "49a7",
	"./javascript.png": "8722",
	"./nickjs.png": "8906",
	"./photoshop.png": "a730",
	"./react.png": "23d5",
	"./spotify.png": "d32e",
	"./tensorflow.png": "9211",
	"./vue.png": "6b1c",
	"./xd.png": "f0e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";